import React from 'react';
import { useNavigate } from 'react-router-dom';
import CountdownToEndOfYear from './components/Countdown';

const NewYearCountdownPage = () => {
  const navigate = useNavigate();

  return <CountdownToEndOfYear onClose={() => navigate('/')} />;
};

export default NewYearCountdownPage;
